/* eslint-disable @typescript-eslint/no-explicit-any */

import { mapManager } from './map-manager'

export class EventManager {
  private listeners: Map<string, naver.maps.MapEventListener[]> = new Map()

  triggerEvent(eventName: string): void {
    mapManager.withMap(map => {
      naver.maps.Event.trigger(map, eventName)
    })
  }

  addEventListener(
    eventName: string,
    callback: (event: any) => any,
  ): naver.maps.MapEventListener | null {
    return mapManager.withMap(map => {
      const listener = map.addListener(eventName, callback)

      if (!this.listeners.has(eventName)) {
        this.listeners.set(eventName, [])
      }
      this.listeners.get(eventName)!.push(listener)

      return listener
    })
  }

  addEventListenerOnce(
    eventName: string,
    callback: (event: any) => any,
  ): naver.maps.MapEventListener | null {
    return mapManager.withMap(map => {
      return map.addListenerOnce(eventName, callback)
    })
  }

  private removeInternalListener(listener: naver.maps.MapEventListener): void {
    for (const [eventName, eventListeners] of this.listeners.entries()) {
      const index = eventListeners.indexOf(listener)
      if (index !== -1) {
        eventListeners.splice(index, 1)

        if (eventListeners.length === 0) {
          this.listeners.delete(eventName)
        }
        break
      }
    }
  }

  removeEventListener(
    listeners: (naver.maps.MapEventListener | undefined)[],
  ): void {
    mapManager.withMap(map => {
      listeners.forEach(listener => {
        if (listener) {
          map.removeListener(listener)
          this.removeInternalListener(listener)
        }
      })
    })
  }

  clearEventListener(eventName: string | string[]): void {
    mapManager.withMap(map => {
      if (Array.isArray(eventName)) {
        eventName.forEach(name => {
          map.clearListeners(name)
          this.listeners.delete(name)
        })
      } else {
        map.clearListeners(eventName)
        this.listeners.delete(eventName)
      }
    })
  }

  clearAllListeners(): void {
    mapManager.withMap(map => {
      this.listeners.forEach((_, eventName) => {
        map.clearListeners(eventName)
      })
      this.listeners.clear()
    })
  }
}

export const eventManager = new EventManager()
